<div class="container">
  <div class="col-md-12">
    <!--    <div class="row button-row">-->
    <!--      <div class="col-md-3"><button mat-raised-button (click)="openAddSyndicationsPipelineModal()" class="add-project-button">Add Project to Pipeline</button></div>-->
  <!--    </div>-->
  @for (state of Object.keys(projects); track state) {
    <div class="row sticky-header-row">
      <div class="col-md-2"><h3 class="header-title">{{state}}</h3></div>
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-4"><strong>Total Gross Equity: </strong>{{getTotals(projects[state]).total_gross_equity | currency: 'USD':'symbol': '1.0-0'}}</div>
          <div class="col-md-4"><strong>Avg. PPC: </strong>{{getTotals(projects[state]).avgPpc | currency: 'USD':'symbol':'1.4-4'}}</div>
          <div class="col-md-4"><strong>Avg. Debt: </strong>{{getTotals(projects[state]).avgDebt | percent : '1.1-1'}}</div>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    @for (status of Object.keys(projects[state]); track status) {
      <div class="table-section">
        <div [ngClass]="'row header-block-' + formatStatusClass(status)">
          <div class="col-md-2"><h5 class="header-subtitle">{{status}}</h5></div>
          <div class="col-md-10">
            <div class="row subtotals">
              <div class="col-md-4"><strong>Total Gross Equity: </strong>
              {{getTotals(projects[state]).subtotals[status].total_gross_equity | currency: 'USD' : 'symbol' : '1.0-0'}}
            </div>
            <div class="col-md-4"><strong>Avg. PPC: </strong>
            {{getTotals(projects[state]).subtotals[status].avgPpc | currency: 'USD' : 'symbol': '1.4-4'}}
          </div>
          <div class="col-md-4"><strong>Avg. Debt%: </strong>
          {{getTotals(projects[state]).subtotals[status].avgDebt | percent: '1.1-1'}}
        </div>
      </div>
    </div>
  </div>
  <table mat-table [dataSource]="projects[state][status]" [ngClass] = "'table-' + formatStatusClass(status) + ' mat-elevation-z4'" matSort (matSortChange)="sortData(status, state, $event)" [multiTemplateDataRows]="true">
    <ng-container matColumnDef="project">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deal Name</th>
      <td mat-cell *matCellDef="let row">
        <a href="{{row.projecturl}}" class="data-link" target="_blank">{{row.project}}</a>
        @if (row.taggedParticipants.length>0) {
          <div (click)="openTagModal(row.taggedParticipants)" class="tag-button"><i class="material-icons" style="font-size: 16px;">sell</i></div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="fund">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet</th>
      <td mat-cell *matCellDef="let row">
        @if (row.fund_name!==null || row.fundurl!==null) {
          <a href="{{row.fundurl}}" class="data-link" target="_blank">{{row.fund_name}}</a>
        }
        @if (row.certificated_name!==null || row.certificatedurl !==null) {
          <a href="{{row.certificatedurl}}" class="data-link" target="_blank">{{row.certificated_name}}</a>
        }
        @if (row.fund_name==null && row.certificated_name==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="credit_type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit Type</th>
      <td mat-cell *matCellDef="let row">
        {{row.credit_type}}
        @if (row.subCredits.length > 0) {
          <div class="expand-button">
            @if (row.isExpanded) {
              <i class="material-icons" (click)="expandPanel(row)">expand_more</i>
            }
            @if (!row.isExpanded) {
              <i class="material-icons" (click)="expandPanel(row)">expand_less</i>
            }
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="ownership">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ownership %</th>
      <td mat-cell *matCellDef="let row">{{row.ownership | percent: '1.4-4'}}</td>
    </ng-container>
    <ng-container matColumnDef="closing_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Closing Date</th>
      <td mat-cell *matCellDef="let row">
        @if (row.closing_date!==null) {
          <span>{{row.closing_date | date: 'MM/dd/yyyy'}}</span>
        }
        @if (row.closing_date==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="admitted_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Admitted Date</th>
      <td mat-cell *matCellDef="let row">
        @if (row.admitted_date!==null) {
          <span>{{row.admitted_date | date: 'MM/dd/yyyy'}}</span>
        }
        @if (row.admitted_date==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="warehoused">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Warehouse</th>
      <td mat-cell *matCellDef="let row">{{row.warehouse == null ? '--' : row.warehouse==true ? 'Yes' : 'No'}}</td>
    </ng-container>
    <ng-container matColumnDef="gross_equity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Gross Equity</th>
      <td mat-cell *matCellDef="let row">
        @if (row.estimated_gross_equity==null && row.gross_equity==null) {
          --
        }
        @if (row.estimated_gross_equity!==null || row.gross_equity!==null) {
          {{row.estimated_gross_equity ?? row.gross_equity | currency: 'USD':'symbol':'1.0-0'}}
          @if (row.estimated_gross_equity==null) {
            <span style="color: gray">**</span>
            }@if (row.estimated_gross_equity!==null) {
            <span style="color: gray">*</span>
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="revenue_year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Revenue Year</th>
      <td mat-cell *matCellDef="let row">
        @if (row.revenue_year!==null) {
          <span>{{row.revenue_year}}</span>
        }
        @if (row.revenue_year==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
      <td mat-cell *matCellDef="let row">{{row.location}}</td>
    </ng-container>
    <ng-container matColumnDef="county">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
      <td mat-cell *matCellDef="let row">{{row.county}}</td>
    </ng-container>
    <ng-container matColumnDef="debt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Debt %</th>
      <td mat-cell *matCellDef="let row">
        @if (row.debt!==null) {
          <span>{{row.debt | percent: '1.1-1'}}</span>
        }
        @if (row.debt==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="ppc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>PPC</th>
      <td mat-cell *matCellDef="let row">
        @if (row.ppc!==null) {
          <span>{{row.ppc | currency: 'USD': 'symbol':'1.4-4'}}</span>
        }
        @if (row.ppc==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="sponsor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary Sponsor</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.sponsorurl}}" class="data-link" target="_blank">{{row.sponsor}}</a></td>
    </ng-container>
    <ng-container matColumnDef="credit_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit Date</th>
      <td mat-cell *matCellDef="let row">
        @if (row.credit_date!==null) {
          <span>{{row.credit_date | date: 'MM/dd/yyyy'}}</span>
        }
        @if (row.credit_date==null) {
          <span>--</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">@if (permissions._edit) {
        <button mat-mini-fab class="edit-btn" (click)="openAssignmentsModal(row)"><i class="material-icons" style="font-size:16px">edit</i></button>
      }</td>
    </ng-container>
    <ng-container matColumnDef="innerTable">
      <td mat-cell *matCellDef="let row" [attr.colspan]="12">
        <table mat-table [dataSource]="row.subCredits">
          <ng-container matColumnDef="credit_type">
            <th mat-header-cell *matHeaderCellDef>Credit Type</th>
            <td mat-cell *matCellDef="let rw">{{rw.credit_type}}</td>
          </ng-container>
          <ng-container matColumnDef="ownership">
            <th mat-header-cell *matHeaderCellDef>Ownership %</th>
            <td mat-cell *matCellDef="let rw">{{rw.ownership | percent: '1.4-4'}}</td>
          </ng-container>
          <ng-container matColumnDef="admitted_date">
            <th mat-header-cell *matHeaderCellDef>Admitted Date</th>
            <td mat-cell *matCellDef="let rw">{{rw.admitted_date | date: 'MM/dd/yyyy'}}</td>
          </ng-container>
          <ng-container matColumnDef="gross_equity">
            <th mat-header-cell *matHeaderCellDef>Gross Equity</th>
            <td mat-cell *matCellDef="let rw">{{rw.gross_equity | currency: 'USD':'symbol':'1.0-0'}}</td>
          </ng-container>
          <ng-container matColumnDef="ppc">
            <th mat-header-cell *matHeaderCellDef>PPC</th>
            <td mat-cell *matCellDef="let rw">{{rw.ppc}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['credit_type', 'ownership', 'admitted_date', 'gross_equity', 'ppc']"></tr>
          <tr mat-row *matRowDef="let rw; columns: ['credit_type', 'ownership', 'admitted_date', 'gross_equity', 'ppc']"></tr>
        </table>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; let i = dataIndex; columns: tableColumns" [ngClass]="{'row-style-alt':i % 2}"></tr>
    <tr mat-row *matRowDef="let row; columns: ['innerTable']" [hidden]="row.subCredits.length == 0 || !row.isExpanded"></tr>
  </table>
</div>
}
<div class="row" style="margin-top: 6px;"><small style="color: gray">* -- Manually estimated gross equity</small></div>
<div class="row"><small style="color: gray">** -- Calculated estimated gross equity (8% load Non-Certificated, 4% load Certificated)</small></div>
}
</div>

</div>
